// Action Types
export const ADD_POST_REQUEST = 'ADD_POST_REQUEST';
export const ADD_POST_SUCCESS = 'ADD_POST_SUCCESS';

// Actions
export const addPostRequest = data => ({ type: ADD_POST_REQUEST, payload: data });
export const addPostSuccess = data => ({ type: ADD_POST_SUCCESS, payload: data });



// WEBPACK FOOTER //
// ./src/app/states/posts/posts.actions.js